module.exports = __webpack_public_path__ + "cf010f4aafbe058dcb8b40ee25476dbf.png";